module.exports = __webpack_public_path__ + "img/workbench_icon1.fc192d91.svg";